module.exports = __webpack_public_path__ + "static/logo-business_insider-b39e9c915ff149474ffb6f1369d2b45e.svg";